import { CacheBase } from "../../core/baseEntity.model";
import { UserCache } from "../account/account.entity";
import { AuthService } from "../core-services/auth.service";

export interface FeedEntityTrait<T> {
    ut: number;
    ot?: boolean;
    ea?: number;
    dt: T[]
}


export const FeedCache = class extends CacheBase {

    static get canonical() {
        return 'f';
     }

    static ref(userId: string = AuthService.instance.currentUser.uid) {
        return `${UserCache.ref(userId)}/${this.canonical}`;
    }

    static readonly child = {
        appointments: 'aps',
        pendingPayments: 'pps',
        closeDuePayments: 'cdps'
    }
}